import { createEvent, createStore, merge } from 'effector';
import { createGate } from 'effector-react';
import { RelatedTickets } from '../types';
import { fxSendMessageToApplicant } from './message-to-applicant';
import {
  fxGetRelatedAvailable,
  fxRelatedCheck,
  fxRelatedSave,
} from './related-available';
import { fxGetList, fxRelatedDelete } from './table';

export const RelatedTicketsGate = createGate<{ id: string }>();

export const $relatedTickets = createStore<RelatedTickets | null>(null);

export const $addRelation = createStore(false);
export const setAddRelation = createEvent<boolean>();

export const $errorRelated = createStore<Error | null>(null);
export const clearError = createEvent();
export const errorOccured = merge([
  fxGetList.fail,
  fxGetRelatedAvailable.fail,
  fxRelatedCheck.fail,
  fxRelatedSave.fail,
  fxRelatedDelete.fail,
  fxSendMessageToApplicant.fail,
]);
